export default __webpack_public_path__ + "static/char-v-41-zh-Hant-c426d3f7c09f82c611c53d53fe08d5f5.mp4";